import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { QuickTradeProto } from "../proto/generated/quick-trade"

export type QuickTradeWidgetStateType = {
    quickTrades: QuickTradeProto[]
    settingsDialogOpen: boolean
    dialogMode: 'addOrEdit' | 'view'
    editTemplateId: string | undefined
}

export const initialState: QuickTradeWidgetStateType = {
    quickTrades: [],
    settingsDialogOpen: false,
    dialogMode: 'addOrEdit',
    editTemplateId: undefined
}

const quickTradeSlice = createSlice({
    name: 'quickTradeSlice',
    initialState,
    reducers: {
        setQuickTrades(state, action: PayloadAction<QuickTradeProto[]>) {
            state.quickTrades = action.payload
            return state
        },
        addOrUpdateQuickTrade(state, action: PayloadAction<QuickTradeProto>) {
            const newQuickTrades = [...state.quickTrades]
            const index = newQuickTrades.findIndex(trade=>trade.id===action.payload.id)
            if(index!==-1) {
                newQuickTrades[index] = action.payload
            } else {
                newQuickTrades.push(action.payload)
            }
            state.quickTrades = newQuickTrades
            return state
        },
        removeQuickTrade(state, action: PayloadAction<string>) {
            const newQuickTrades = [...state.quickTrades].filter(s=>s.id!==action.payload)
            state.quickTrades = newQuickTrades
            return state
        },
        setOpenQuickTradeSettingsDialog(state, action: PayloadAction<{
            settingsDialogOpen: boolean
            dialogMode: 'addOrEdit' | 'view'
            editTemplateId: string | undefined
        }>) {
            return {
                ...state,
                settingsDialogOpen: action.payload.settingsDialogOpen,
                dialogMode: action.payload.dialogMode,
                editTemplateId: action.payload.editTemplateId
            }
        },
    }
})

const { actions, reducer } = quickTradeSlice

export const { setQuickTrades, addOrUpdateQuickTrade, removeQuickTrade, setOpenQuickTradeSettingsDialog } = actions

export default reducer